const columnDataGrid = [
  {
    dataField: 'qcId',
    caption: 'Номер СК',
    dataType: 'string',
    groupIndex: 1
  },
  {
    dataField: 'batchId',
    caption: 'Партия SAP',
    dataType: 'string',
    groupIndex: 2
  },
  {
    dataField: 'cgId',
    caption: 'Номер партии',
    dataType: 'string',
    groupIndex: 3
  },
  {
    dataField: 'actualPieceId',
    caption: 'Номер УЕ',
    dataType: 'string',
    groupIndex: 4
  },
  {
    dataField: 'quantity',
    caption: 'Кол-во',
    dataType: 'number',
    groupIndex: 5
  },
  {
    dataField: 'quantityRemain',
    caption: 'Кол-во ост.',
    dataType: 'number',
    groupIndex: 6
  },
  {
    dataField: 'unitShortName',
    caption: 'ЕИ ПФ',
    dataType: 'string',
    groupIndex: 7
  },
  {
    dataField: 'percentWasteMaterial',
    caption: '% отходов',
    dataType: 'number',
    groupIndex: 8
  },
  {
    dataField: 'weightCurrent',
    caption: 'Тек. кол-во',
    dataType: 'number',
    groupIndex: 9
  },
  {
    dataField: 'weightWasteMaterialCurrent',
    caption: 'Кол-во всех отходов, текущее',
    notVisible: true,
    dataType: 'number',
    groupIndex: 10
  },
  {
    dataField: 'pieceNumId',
    caption: 'Ключ УЕ ПФ',
    notVisible: true,
    dataType: 'number',
    groupIndex: 11
  }
];
const columnDetailGrid1 = [
  {
    dataField: 'matnrComp',
    caption: 'Номер материала',
    dataType: 'number',
    width: 200
  },
  {
    dataField: 'matnrCompText',
    caption: 'Наименование отходов',
    dataType: 'string'
  }
];
const columnDetailGrid2 = [
  {
    dataField: 'weight',
    caption: 'Кол-во текущее',
    dataType: 'number'
  },
  {
    dataField: 'unitOfMeasureShortName',
    caption: 'ЕИ отх.',
    dataType: 'string'
  }
];
export { columnDataGrid, columnDetailGrid1, columnDetailGrid2 };
